<template lang="pug">
.caseGuide
  .Guide-box
    Form(:model="question")
      .Guide-stem
        FormItem
          //- Input.input1(type='text',placeholder='标题',v-model='question.title')
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
        FormItem
          Upload(ref="upload",:before-upload="(file)=>handleUpload(file)",multiple,:show-upload-list="true",:on-remove="handleRemoveFile"
            :max-size="10240"
            :default-file-list="JSON.parse(question.stem) || []"
            action=" " style="display:block;")
            Button.button + 上传文件
            p.uploadDesc 文件格式支持pdf、doc、docx、xls、xlsx、ppt、pptx，文件大小限制10M。
</template>
<script>
import iDelModel from "@/components/common/iDelModel";
export default {
  components: {
    iDelModel
  },
  props: ["data"],
  data() {
    return {
      question: {
        // id: "",
        stem: "[]"
        // tsId: ""
      }
    };
  },
  methods: {
    handleRemoveFile(file, fileList) {
      this.question.stem = JSON.stringify(fileList);
    },
    async handleUpload(file) {
      const fileType = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx"];
      if (!fileType.includes(file.name.slice(file.name.lastIndexOf(".")))) {
        this.$Message.warning("文件类型不正确！");
        return false;
      }
      if (file.size > 10485760) {
        this.$Message.warning("文件大小不能超过10M！");
        return false;
      }
      try {
        const { data } = await this.$http.MaterialsUploadFile(file);
        console.log(
          {
            name: file.name,
            url: data.data
          },
          "file"
        );
        console.log(this.question.stem, "push");
        const arr = JSON.parse(this.question.stem);
        arr.push({
          name: file.name,
          url: data.data
        });
        this.$nextTick(() => {
          this.question.stem = JSON.stringify(arr);
          console.log("🚀 ~ this.$nextTick ~ this.question.stem:", this.question.stem);
        });
      } catch (error) {
        return false;
      }
      console.log(this.question.stem, "stem");
      return false;
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="stylus">
.caseGuide
  .Guide-box
    padding 24px
    width 100%
    margin 0 auto
    .Guide-stem
      position relative
      .ide
        margin-top -10px
      .input1
        width 80%
        float left
      .ivu-form-item-content
        // margin-right 300px
      .btns
        position absolute
        top -5px
        right 0px
        .ivu-icon
          color #3A76D2FF
          font-size 22px
          top 0
          margin-right 12px
          background #F2F5FAFF
          width 24px
          height 24px
          border-radius 4px
          text-align center
          line-height @height
          &:hover
            cursor pointer
</style>
<style lang="less" scoped>
.uploadDesc {
  font-size: 12px;
  font-family: MicrosoftYaHeiUI;
  color: rgba(128, 128, 128, 0.5);
}
</style>
